import Marquee from 'react-fast-marquee';
const EDU_OFFICE_LOGOS = [{
  src: '/assets/pricing/edu-office/seoul.webp',
  alt: '서울특별시교육청'
}, {
  src: '/assets/pricing/edu-office/incheon.webp',
  alt: '인천광역시교육청'
}, {
  src: '/assets/pricing/edu-office/busan.webp',
  alt: '부산광역시교육청'
}, {
  src: '/assets/pricing/edu-office/jeonnam.webp',
  alt: '전라남도교육청'
}, {
  src: '/assets/pricing/edu-office/gyeongbuk.webp',
  alt: '경상북도교육청'
}, {
  src: '/assets/pricing/edu-office/daegu.webp',
  alt: '대구광역시교육청'
}, {
  src: '/assets/pricing/edu-office/gwangju.webp',
  alt: '광주광역시교육청'
}, {
  src: '/assets/pricing/edu-office/sejong.webp',
  alt: '세종특별자치시교육청'
}];

/**
 * 요금제 Hero 아래 — 사용 학교 수 통계 + 교육청 로고 무한 마퀴.
 * 마퀴 인터랙션은 web-app 랜딩(HorizontalTicker)과 시각적으로 동일하게 왼쪽 흐름.
 * isKR 전용 (호출부에서 게이팅).
 */
export const SchoolUsageBanner = () => {
  return <section className="flex flex-col items-center gap-sm bg-default px-md pb-2xl pt-sm" data-sentry-component="SchoolUsageBanner" data-sentry-source-file="SchoolUsageBanner.tsx">
      <p className="max-w-[1280px] px-md text-center text-[17px] font-medium leading-[140%] text-default tablet-sm:text-[20px] tablet-sm:font-semibold">
        전국{' '}
        <span className="font-bold tablet-sm:font-extrabold">
          11,248개 학교
        </span>
        ,{' '}
        <span className="font-bold tablet-sm:font-extrabold">
          81,445명 선생님
        </span>
        께서 <br className="tablet-lg:hidden" />
        ZEP QUIZ를 사용하고 있습니다.
      </p>
      {/* 로고 마퀴는 위 통계 문구를 시각적으로 보강하는 장식 요소 — autoFill 복제분이 스크린리더에 반복 낭독되지 않도록 영역을 aria-hidden 처리 */}
      <div aria-hidden className="w-full overflow-hidden">
        <Marquee autoFill direction="left" gradient={false} speed={40} data-sentry-element="Marquee" data-sentry-source-file="SchoolUsageBanner.tsx">
          {EDU_OFFICE_LOGOS.map(logo => <img key={logo.src} src={logo.src} alt={logo.alt} className="mr-md h-[46px] w-auto object-contain tablet-lg:mr-xl tablet-lg:h-[72px]" />)}
        </Marquee>
      </div>
    </section>;
};